import { useResetPasswordMutation } from "app/store/auth/api/resetPasswordApi";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { TOAST_SEVERITY } from "static/constants";
import { showToast } from "utils/toast";

const useResetPasswordForm = () => {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [confirmPasswordTouched, setConfirmPasswordTouched] = useState(false);

  const [passwordLengthValid, setPasswordLengthValid] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [confirmPasswordValid, setConfirmPasswordValid] = useState(false);

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const [resetPassword] = useResetPasswordMutation();

  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      const result = await resetPassword({
        token,
        newPassword: password,
        confirmPassword: confirmPassword,
      }).unwrap();

      if (result) {
        showToast({ message: result.message });
        navigate("/login");
      }
    } catch (error) {
      showToast({
        type: TOAST_SEVERITY.ERROR,
        message: error.message || "Something went wrong, please try again.",
      });
    }
  };

  const handlePasswordChange = (e) => {
    const val = e.target.value;
    setPasswordTouched(true);
    setPassword(val);
    var pattern = new RegExp(
      /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*].*$/
    );
    const isValid = pattern.test(val);
    if (isValid) {
      setPasswordValid(true);
    } else {
      setPasswordValid(false);
    }
    if (val.length < 12) {
      setPasswordLengthValid(false);
    } else {
      setPasswordLengthValid(true);
    }

    if (val !== confirmPassword) {
      setConfirmPasswordValid(false);
    } else {
      setConfirmPasswordValid(true);
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const val = e.target.value;
    setConfirmPasswordTouched(true);
    setConfirmPassword(val);

    if (val !== password) {
      setConfirmPasswordValid(false);
    } else {
      setConfirmPasswordValid(true);
    }
  };

  const togglePasswordVisible = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisible = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  return {
    passwordTouched,
    confirmPasswordTouched,
    passwordLengthValid,
    passwordValid,
    confirmPasswordValid,
    passwordVisible,
    password,
    confirmPassword,
    confirmPasswordVisible,

    onSubmit,
    handlePasswordChange,
    handleConfirmPasswordChange,
    togglePasswordVisible,
    toggleConfirmPasswordVisible,
  };
};

export default useResetPasswordForm;
